import React from "react";
import {Button, Card, CardBody, Form, Modal, Spinner} from "reactstrap";
import Api from "../../components/helpers/Api";
import withNavigationHook from "../../hooks/withNavigationHook";
import { debugLog } from "../../utils/debug";

class SubscriptionDetails extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            subscription: null,
            paymentHistory: [],
            loading: true,
            error: null,
            canceling: false,
        };
    }

    toggleModal = (state) => {
        this.setState({
            [state]: !this.state[state],
        });
    };

    async componentDidMount() {
        const { customerId } = this.props; // Passed as a prop from the parent component

        try {
            // Fetch subscription details
            const subscriptionResponse = await Api.post(`/payment/get-subscription`, { customerId });
            const paymentHistoryResponse = await Api.post(`/payment/get-payment-history`, { customerId });

            debugLog("Subscription API Response:", subscriptionResponse.data);
            debugLog("Payment History API Response:", paymentHistoryResponse.data);

            // Extract first subscription if response is an array
            const subscription = Array.isArray(subscriptionResponse.data) && subscriptionResponse.data.length > 0
                ? subscriptionResponse.data[0]
                : null;

            this.setState({
                subscription,
                paymentHistory: paymentHistoryResponse.data || [],
                loading: false,
            });
        } catch (error) {
            console.error("Error fetching subscription details:", error);
            this.setState({ error: "Failed to load subscription data", loading: false });
        }
    }

    // Handle the cancel subscription request
    handleCancelSubscription = async () => {
        const { customerId } = this.props;
        const { subscription } = this.state;

        if (!subscription) {
            return; // No subscription to cancel
        }

        this.setState({ canceling: true });

        try {
            // Call your backend to cancel the subscription
            const response = await Api.post(`/payment/cancel-subscription`, { customerId, subscriptionId: subscription.id });

            if (response.data.success) {
                // Update the UI to reflect the canceled subscription
                this.setState({
                    subscription: { ...subscription, status: "canceled" },
                    canceling: false,
                });

                sessionStorage.clear();
                this.props.navigation("/your-profile/subscription-cancelled");
            } else {
                this.setState({ canceling: false });

                // TODO: Show a nice message to the user saying there was an error
                // alert("Failed to cancel subscription");     // TODO: remove
            }
        } catch (error) {
            console.error("Error canceling subscription:", error);
            this.setState({ canceling: false });
            this.setState({ error: "Error canceling subscription, please try again later." });
        }

        this.toggleModal("formModalCancelSubscription");
    };

    render() {
        const { subscription, paymentHistory, loading, error, canceling } = this.state;

        if (loading) return <>
            <div className="spinner-container">
                <Spinner animation="border" role="status">
                    <span className="visually-hidden"></span>
                </Spinner>
                &nbsp;Loading...
            </div>
        </>;
        if (error) return <>
            <p className="text-danger">
                {error}
            </p>
            <p className="text-danger">
                If you are still having issues please <a href='/contact-us' className="text-danger">Contact Us</a>.
            </p>
        </>;

        return (
            <div className="p-6 border rounded-xl shadow-lg">
                <h7 className="text-primary text-uppercase">Subscription Details</h7>

                {subscription ? (
                    <>
                        {/*<p className="description mt-3"><strong>Plan:</strong> {subscription.plan_name || "Unknown Plan"}</p> /!* Fallback for missing plan_name *!/*/}
                        <p className="description mt-3"><strong>Amount: &pound;</strong>{(subscription.amount / 100).toFixed(2)} {subscription.currency}</p>
                        <p className="description mt-3"><strong>Status:</strong> {subscription.status}</p>
                        <p className="description mt-3"><strong>Next Billing Date:</strong> {new Date(subscription.next_billing_date).toDateString()}</p>

                        {/* Cancel Subscription Button */}
                        <Button
                            color="danger"
                            className="mt-4"
                            onClick={() => this.toggleModal("formModalCancelSubscription")}
                            disabled={canceling}  // Disable the button while canceling
                        >
                            {canceling ? "Canceling..." : "Cancel Subscription"}
                        </Button>

                        <h3 className="mt-6 text-xl font-semibold">Payment History</h3>
                        {paymentHistory.length > 0 ? (
                            <ul className="mt-3">
                                {paymentHistory.map((invoice) => (
                                    <li key={invoice.invoice_id} className="description mt-3 mb-2">
                                        {new Date(invoice.date).toDateString()} - &pound;{(invoice.amount_paid / 100).toFixed(2)} {invoice.currency} ({invoice.status})
                                        <a href={invoice.invoice_url} target="_blank" rel="noopener noreferrer" className="text-blue-600 ml-2">
                                            View Invoice
                                        </a>
                                    </li>
                                ))}
                            </ul>
                        ) : (
                            <p>No payment history found.</p>
                        )}

                        <Modal
                            className="modal-dialog-centered"
                            size="sm"
                            isOpen={this.state.formModalCancelSubscription}
                            toggle={() => this.toggleModal("formModalCancelSubscription")}
                        >
                            <div className="modal-header">
                                <h2 style={{fontSize: '1rem'}} className="modal-title" id="modal-title-default">
                                    Cancel subscription
                                </h2>
                                <button
                                    aria-label="Close"
                                    className="close"
                                    data-dismiss="modal"
                                    type="button"
                                    onClick={() => this.toggleModal("formModalCancelSubscription")}
                                >
                                    <span aria-hidden={true}>×</span>
                                </button>
                            </div>
                            <div className="modal-body p-0">
                                <Card className="bg-secondary shadow border-0">
                                    <CardBody className="px-lg-5 py-lg-5">
                                        <div className="text-center text-muted mb-4">
                                            Your subscription will remain active until the end of the current billing period. Your worship plans and data are fully preserved.
                                        </div>
                                        <Form role="form">
                                            <div className="text-center">
                                                <Button
                                                    className="my-4"
                                                    color="danger"
                                                    type="button"
                                                    onClick={() => this.handleCancelSubscription()}
                                                >
                                                    <i className="fa fa-share-alt" aria-hidden="true"></i>
                                                    <span className="btn-inner--text">Confirm Cancellation</span>
                                                </Button>
                                            </div>
                                        </Form>
                                    </CardBody>
                                </Card>
                            </div>
                        </Modal>
                    </>
                ) : (
                    <>
                        <p>No active subscriptions found.</p>
                        <p className="text-muted small mt-2">
                            If you recently updated your payment method, it may take a moment to appear here.
                        </p>
                    </>
                )}
            </div>
        );
    }
}

export default withNavigationHook(SubscriptionDetails);
